import { differenceInCalendarDays } from "date-fns"

/**
 * Relative dates for the announcements bell.
 *
 * A notification list is read as "what happened recently", so an absolute date makes the
 * reader do the arithmetic. The exact day is still one hover away in the row's `title`.
 *
 * Calendar days, not elapsed hours: something posted at 23:50 yesterday is "Yesterday" at
 * 00:10 today, not "an hour ago".
 */

export const RELATIVE_GROUP_TODAY = 'Today'
export const RELATIVE_GROUP_WEEK = 'This week'
export const RELATIVE_GROUP_EARLIER = 'Earlier'

export function formatRelativeDate(date) {
	const days = differenceInCalendarDays(new Date(), date)
	if (days <= 0) return 'Today'
	if (days === 1) return 'Yesterday'
	if (days < 7) return `${days} days ago`
	if (days < 30) {
		const weeks = Math.floor(days / 7)
		return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`
	}
	const months = Math.floor(days / 30)
	return months === 1 ? '1 month ago' : `${months} months ago`
}

/** Which bucket a row belongs to in the bell's panel. */
export function relativeDateGroup(date) {
	const days = differenceInCalendarDays(new Date(), date)
	if (days <= 0) return RELATIVE_GROUP_TODAY
	if (days < 7) return RELATIVE_GROUP_WEEK
	return RELATIVE_GROUP_EARLIER
}
